export enum WaiterHubEnum{
    order="order",
    waiterCall="waiterCall",
    waiterEndCall="WaiterEndCall"
}